/*global define:false*/
define('notFoundView',['grasshopperBaseView', 'notFoundViewConfig'],
    function (GrasshopperBaseView, notFoundViewConfig) {
        'use strict';

        return GrasshopperBaseView.extend({
            defaultOptions: notFoundViewConfig
        });

    });

